import { Component, ChangeDetectionStrategy, input, ViewEncapsulation, forwardRef, output, contentChild, TemplateRef } from "@angular/core";
import { InputFormWrapper } from "../wrapper.interface";
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { AutoComplete, AutoCompleteModule } from "primeng/autocomplete";
import { V_FORM_CONTROL_TOKEN, WRAPPER_TOKEN } from "../wrapper.tokens";
import { AutocompleteConfig } from "./autoComplete.config";

@Component({
    selector:    'v-autoComplete',
    templateUrl: './autoComplete.component.haml',
    styleUrls:   ['./autoComplete.component.sass', '../input.style.sass'],
    providers:   [
        { provide: V_FORM_CONTROL_TOKEN, useExisting: forwardRef(() => VAutoCompleteComponent) },
        { provide: WRAPPER_TOKEN, useExisting: forwardRef(() => VAutoCompleteComponent) },
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => VAutoCompleteComponent), multi: true }
    ],
    encapsulation:   ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports:         [CommonModule, AutoCompleteModule, ReactiveFormsModule]
})
export class VAutoCompleteComponent<T = unknown> extends InputFormWrapper<AutocompleteConfig, T[]> {
    protected _baseConfig: AutocompleteConfig = AutocompleteConfig.baseTheme.Default;

    public readonly itemTemplate = contentChild<TemplateRef<unknown>>('item');
    public readonly emptyTemplate = contentChild<TemplateRef<unknown>>('empty');
    public readonly headerTemplate = contentChild<TemplateRef<unknown>>('header');
    public readonly footerTemplate = contentChild<TemplateRef<unknown>>('footer');
    public readonly selectedItemTemplate = contentChild<TemplateRef<unknown>>('selectedItem');
    public readonly groupTemplate = contentChild<TemplateRef<unknown>>('group');
    public readonly loaderTemplate = contentChild<TemplateRef<unknown>>('loader');
    public readonly removeiconTemplate = contentChild<TemplateRef<unknown>>('removeicon');
    public readonly loadingiconTemplate = contentChild<TemplateRef<unknown>>('loadingicon');
    public readonly cleariconTemplate = contentChild<TemplateRef<unknown>>('clearicon');
    public readonly dropdowniconTemplate = contentChild<TemplateRef<unknown>>('dropdownicon');

    public get value() {
        return this._value;
    }

    public set value(value: T[]) {
        this._value = value;
    }

    public suggestions = input.required<unknown[]>();
    /**
     * Method to prompt new suggestions based on the user's search term
     */
    public searchMethod = input<(searchTerm: string) => void>();

    public onShow = output<Event>();
    public onHide = output<Event>();
    public onKeyUp = output<KeyboardEvent>();
    public onSelect = output<T>();

    get wrappedComponent() {
        return super.wrappedComponent as AutoComplete;
    }

    public clearInput() {
        const component = this.wrappedComponent as AutoComplete;
        component.updateInputValue();
    }
}